import { Button, Text } from '@radix-ui/themes';
import { MachineContext, MachineDialogMode } from 'contexts/machine.context';
import { t } from 'i18next';
import { QueueState } from 'lib_ts/enums/machine-msg.enum';
import { RADIX, RadixBtnSize, RadixBtnVariant } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';
import useMachineStatusStore from 'stores/use-machine-status-store';

interface IProps {
  variant?: RadixBtnVariant;
  size?: RadixBtnSize;
  /** applied to the button tag */
  className?: string;
}

export const MachineUnavailableButton = (props: IProps) => {
  const queueState = useMachineStatusStore((s) => s.queueState);

  const { openDialog, reconnect } = useContext(MachineContext);

  switch (queueState) {
    case QueueState.Busy: {
      return (
        <Button
          size={props.size}
          variant={props.variant}
          color={RADIX.COLOR.WARNING}
          className={props.className}
          onClick={() => openDialog(MachineDialogMode.RequestControl)}
        >
          <Text truncate>{t('common.busy')}</Text>
        </Button>
      );
    }

    case QueueState.UserDC: {
      return (
        <Button
          size={props.size}
          variant={props.variant}
          color={RADIX.COLOR.WARNING}
          className={props.className}
          onClick={reconnect}
        >
          <Text truncate>{t('common.click-to-reconnect')}</Text>
        </Button>
      );
    }

    case QueueState.MachineDC:
    default: {
      return (
        <Button
          size={props.size}
          variant={props.variant}
          color={RADIX.COLOR.DANGER}
          className={props.className}
          onClick={reconnect}
        >
          <Text truncate>{t('common.machine-offline')}</Text>
        </Button>
      );
    }
  }
};
